/** @jsxImportSource theme-ui @jsxRuntime classic */
import { TabMenu as TabMenuComponent } from '@tishman/components';
import React, { useContext } from 'react';

import { TIME_PERIODS } from '../../../constants';
import { BuyTicketsLayoutContext } from '../../../layouts/BuyTicketsLayout';
import { useGetAvailableTimeSlot } from '../../../utils/use-get-available-time-slot';
import { useScrollToTimeSlot } from '../../../utils/use-scroll-to-time-slot';

/**
 * @see BuyTicketsLayoutProvider for functionality of tabs changing on scroll
 **/
export const TabMenu = ({
  hasDiscountedPerformances = false,
}: {
  hasDiscountedPerformances?: boolean;
}) => {
  const { selectedTimePeriod, setSelectedTimePeriod } = useContext(
    BuyTicketsLayoutContext,
  );
  const { scrollToSlot } = useScrollToTimeSlot();
  const { getAvailableTimeSlot } = useGetAvailableTimeSlot();

  const onTabChange = (timePeriod: number) => {
    setSelectedTimePeriod(timePeriod);

    const timeSlot = getAvailableTimeSlot(timePeriod);
    const timeSlotEl = document.getElementById(timeSlot?.ak ?? '');

    if (timeSlotEl) {
      scrollToSlot(timeSlotEl as HTMLButtonElement);
    }
  };

  return (
    <TabMenuComponent
      hasDiscountedPerformances={hasDiscountedPerformances}
      labels={[...TIME_PERIODS]}
      onTabChange={onTabChange}
      tab={selectedTimePeriod}
    />
  );
};
